module.exports = __webpack_public_path__ + "img/cloud-upload.670bf160.svg";